import { render, staticRenderFns } from "./MerchantEditZhongfu.vue?vue&type=template&id=70dc8b55&scoped=true&"
import script from "./MerchantEditZhongfu.vue?vue&type=script&lang=js&"
export * from "./MerchantEditZhongfu.vue?vue&type=script&lang=js&"
import style0 from "./MerchantEditZhongfu.vue?vue&type=style&index=0&id=70dc8b55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dc8b55",
  null
  
)

export default component.exports